import { Link } from "react-router-dom";

import { Space, Breadcrumb, Button } from "antd";
import type { ColumnsType } from "antd/es/table";
import { PageHeader } from "@ant-design/pro-layout";

import {
   Site, ApiKey
} from "../../model/model";
import SessionStore from "../../model/SessionStore";

import type { GetPageCallbackFunc } from "../../components/DataTable";
import DataTable from "../../components/DataTable";

interface IProps {
  site: Site;
}

function ListSiteApiKeys(props: IProps) {
  const columns: ColumnsType<ApiKey> = [
    {
      title: "name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => <Link to={`/site/${props.site.id}/api-key/${record.id}/edit`}>{text}</Link>,
    },
  ];

  const getPage = (limit: number, offset: number, callbackFunc: GetPageCallbackFunc) => {
    const siteId :string = props.site.id;
    SessionStore.getClient().getSiteApiKeys(siteId, SessionStore.getBearer()).then( (resp) => {
      const obj = resp.data;
      callbackFunc(obj.length, obj);
    });
  };

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Sites</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to={`/site/${props.site.id}/dash`}>{props.site.name}</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>Site apikeys</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title="Site apikeys"
        extra={[
            <Button type="primary">
              <Link to={`/site/${props.site.id}/api-keys/create`}>Add site api-key</Link>
            </Button>
        ]}
      />
      <DataTable columns={columns} getPage={getPage} rowKey="id" />
    </Space>
  );
}

export default ListSiteApiKeys;
